import { IMeta } from 'app/core/models/api/data';
import { IPagination } from 'app/core/models/api/pagination';

export const DEFAULT_PAGINATION = 25;
export const CUSTOMER_ITEMS_PAGINATION = 25;
export const CUSTOMER_MOVEMENTS_ITEMS_PAGINATION = 25;
export const BILLING_ITEMS_PAGINATION = 25;
export const KIWID_PLAN_INVOICES_ITEMS_PAGINATION = 25;
export const PRODUCT_ITEMS_PAGINATION = 25;
export const REPORT_PAGINATION = 25;
export const MAX_PER_PAGE_PAGINATION = 50;
export const DELIVERY_ROUTE_PAGINATION = 25;
export const PEOPLE_PAGINATION = 40;
export const TAGS_PAGINATION = 40;
export const REQUEST_LIMIT = 150;
export const STAGE_SELECT_LIMIT = 50;
export const MODAL_SELECT_CHECK_PAGINATION = 25;

export const GET_ALL_PAGINATION = 50000000;

export const FAKE_PAGINATION_META: IMeta<IPagination> = {
    pagination: {
        count: 0,
        limit: 0,
        offset: 0,
        total: 0,
    },
};
export const K_SELECT_PAGINATION = 10;
